import { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUserData } from "../../store/user/selectors";
import { canAccess, getLandingRoute, Page } from "../../utils/auth";

type RoleGuardProps = PropsWithChildren<{ page: Page }>;

// Renders the page only if the user's roles open it (see PAGE_ROLES);
// otherwise sends them to the first page they are allowed to see.
const RoleGuard = ({ page, children }: RoleGuardProps) => {
    useSelector(selectUserData); // re-render once roles load

    if (canAccess(page)) {
        // @ts-ignore
        return <>{children}</>;
    }
    const landing = getLandingRoute();
    return landing ? <Navigate to={`/${landing}`} replace /> : null;
};

export default RoleGuard;
